import { ExpandLess, ExpandMore } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Button, Collapse, IconButton, List, ListItemButton, ListItemText, Menu, MenuItem, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
    const theme = useTheme()
    const phone = useMediaQuery(theme.breakpoints.between(280, 830))
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [anchorElTranslate, setAnchorElTranslate] = React.useState(null);
    const openTranslate = Boolean(anchorElTranslate);
    const [selectedIndex, setSelectedIndex] = React.useState("/images/flag/iran-32.png");
    const open = Boolean(anchorEl);
    const handleClickListItem = (event) => {
        if (anchorElTranslate) {

            setAnchorElTranslate(null);
        } else {
            setAnchorElTranslate(event.currentTarget);

        }
    };


    const handleCloseTranslate = () => {
        setAnchorElTranslate(null);
    };
    const navigate = useNavigate()
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleTranslate = (src) => {
        setSelectedIndex(src)
        setAnchorElTranslate(null);
        if (src.includes("iran")) {
            window.location.href = "#"
        } else if (src.includes("saudi")) {
            window.location.href = "https://jansnak-com.translate.goog/home/?_x_tr_sl=fa&_x_tr_tl=ar&_x_tr_hl=en&_x_tr_pto=wapp"

        } else if (src.includes("turkey")) {
            window.location.href = "https://jansnak-com.translate.goog/home/?_x_tr_sl=fa&_x_tr_tl=tr&_x_tr_hl=en&_x_tr_pto=wapp"

        } else if (src.includes("united")) {
            window.location.href = "https://jansnak-com.translate.goog/home/?_x_tr_sl=fa&_x_tr_tl=en&_x_tr_hl=en&_x_tr_pto=wapp"
        } else if (src.includes("china")) {
            window.location.href = "https://jansnak-com.translate.goog/home/?_x_tr_sl=fa&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
        }


    }
    const Title = ({ title, to, target }) => {
        return (
            <Link to={to} style={{ textDecoration: 'none', color: !phone ? "#fff" : "#000" }} target={target} onClick={() => {
                setAnchorEl(null)
                window.scrollTo(0, 0);
            }}>
                <p style={{ fontSize: '14px', color: !phone ? "#fff" : "#000" }}> {title}</p>
            </Link>)

    }
    return (
        <AppBar position='sticky' elevation={1} sx={{ bgcolor: "#424242", p: "10px", width: '100%' }} >

            {phone ?
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <IconButton onClick={handleClick}  >
                        <MenuIcon sx={{ color: '#fff' }} />
                    </IconButton>
                    <Link to="/" onClick={() => window.location.href = "/"}>
                        <img src="/images/logo.png" alt="جان اسنک" width={phone ? "33px" : "50px"} style={{ padding: '5px' }} />
                    </Link>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                            dir: 'rtl'
                        }}
                    >
                        <MenuItem ><Title title={"صفحه نخست"} to={'/home'} /></MenuItem>
                        <MenuItem ><Title title={" فرانچایزینگ / درخواست شعبه"} to={'https://superapp.jansnak.com/franchizing'} /></MenuItem>
                        <MenuItem >
                            <List sx={{ width: '100%', p: 0 }}>
                                <ListItemButton
                                    sx={{ width: '100%' }}

                                    onClick={handleClickListItem}
                                >
                                    <ListItemText sx={{ display: 'flex', gap: 3 }}>
                                        <img src={selectedIndex} />
                                    </ListItemText>
                                    {openTranslate ? <ExpandLess /> : <ExpandMore />}

                                </ListItemButton>
                                <Collapse in={openTranslate} timeout="auto" unmountOnExit>
                                    <List

                                        id="demo-positioned-menu"
                                        aria-labelledby="demo-positioned-button"
                                        anchorEl={anchorElTranslate}
                                        open={openTranslate}
                                        onClose={handleCloseTranslate}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}

                                    >
                                        <ListItemButton onClick={() => handleTranslate("/images/flag/iran-32.png")}>
                                            <Box display={"flex"} alignItems={"center"} gap={4}>
                                                <img src="/images/flag/iran-32.png" />
                                                <Typography variant='body2'>فارسی</Typography>
                                            </Box>
                                        </ListItemButton>
                                        <ListItemButton onClick={() => handleTranslate("/images/flag/saudi arabia-32.png")}>
                                            <Box display={"flex"} alignItems={"center"} gap={4}>
                                                <img src="/images/flag/saudi arabia-32.png" />
                                                <Typography variant='body2'>العربیة</Typography>
                                            </Box>
                                        </ListItemButton>
                                        <ListItemButton onClick={() => handleTranslate("/images/flag/united kingdom-32.png")}>
                                            <Box display={"flex"} alignItems={"center"} gap={3}>
                                                <img src="/images/flag/united kingdom-32.png" />
                                                <Typography variant='body2'>English</Typography>
                                            </Box>
                                        </ListItemButton>
                                        <ListItemButton onClick={() => handleTranslate("/images/flag/turkey-32.png")}>
                                            <Box display={"flex"} alignItems={"center"} gap={3.2}>
                                                <img src="/images/flag/turkey-32.png" />
                                                <Typography variant='body2'>Türkçe</Typography>
                                            </Box>
                                        </ListItemButton>
                                        <ListItemButton onClick={() => handleTranslate("/images/flag/china-32.png")}>
                                            <Box display={"flex"} alignItems={"center"} gap={3.2}>
                                                <img src="/images/flag/china-32.png" />
                                                <Typography variant='body2'>中国人</Typography>
                                            </Box>
                                        </ListItemButton>

                                    </List>
                                </Collapse>
                            </List>
                        </MenuItem>
                        <MenuItem ><Title title={"پلتفرم جان "} target={"_blank"} to={'https://jansnak.com/portal'} /> </MenuItem>
                        <MenuItem ><Title title={"تور مجازی "} target={"_blank"} to={'https://tour.jansnak.com'} /></MenuItem>
                        <MenuItem ><Title title={" دانلود اپلیکیشن "} to={'download'} /></MenuItem>
                        <MenuItem ><Title title={" شکایات/پیگیری"} to={'complaint'} /></MenuItem>
                        <MenuItem ><Title title={" شعبه یاب جان"} target={"_blank"} to={'https://superapp.jansnak.com/nearBranch'} /></MenuItem>
                        <MenuItem ><Title title={" تماس با ما"} to={`contact/${0}`} /></MenuItem>
                    </Menu>

                </Box>
                :
                <Box display={"flex"} justifyContent={"space-around"} alignItems={"center"} p=" 0 30px">
                    <Button target="_blank" onClick={() => window.location.href = "https://superapp.jansnak.com/franchizing"} variant='contained' sx={{ p: "7px", bgcolor: '#EF7C00', color: '#000', fontWeight: 700, borderRadius: '20px' }}> فرانچایزینگ / درخواست شعبه</Button>
                    <Button
                        id="demo-positioned-button"
                        aria-controls={openTranslate ? 'demo-positioned-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openTranslate ? 'true' : undefined}
                        onClick={handleClickListItem}
                    >
                        <img src={selectedIndex} />
                    </Button>
                    <Menu
                        sx={{ top: 50 }}
                        id="demo-positioned-menu"
                        aria-labelledby="demo-positioned-button"
                        anchorEl={anchorElTranslate}
                        open={openTranslate}
                        onClose={handleCloseTranslate}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <MenuItem onClick={() => handleTranslate("/images/flag/iran-32.png")}>
                            <Box display={"flex"} alignItems={"center"} gap={4}>
                                <img src="/images/flag/iran-32.png" />
                                <Typography variant='body2'>فارسی</Typography>
                            </Box>
                        </MenuItem>
                        <MenuItem onClick={() => handleTranslate("/images/flag/saudi arabia-32.png")}>
                            <Box display={"flex"} alignItems={"center"} gap={4}>
                                <img src="/images/flag/saudi arabia-32.png" />
                                <Typography variant='body2'>العربیة</Typography>
                            </Box>
                        </MenuItem>
                        <MenuItem onClick={() => handleTranslate("/images/flag/united kingdom-32.png")}>
                            <Box display={"flex"} alignItems={"center"} gap={3}>
                                <img src="/images/flag/united kingdom-32.png" />
                                <Typography variant='body2'>English</Typography>
                            </Box>
                        </MenuItem>
                        <MenuItem onClick={() => handleTranslate("/images/flag/turkey-32.png")}>
                            <Box display={"flex"} alignItems={"center"} gap={3.2}>
                                <img src="/images/flag/turkey-32.png" />
                                <Typography variant='body2'>Türkçe</Typography>
                            </Box>
                        </MenuItem>
                        <MenuItem onClick={() => handleTranslate("/images/flag/china-32.png")}>
                            <Box display={"flex"} alignItems={"center"} gap={3.2}>
                                <img src="/images/flag/china-32.png" />
                                <Typography variant='body2'>中国人</Typography>
                            </Box>
                        </MenuItem>

                    </Menu>
                    <Title title={"صفحه نخست"} to={'/home'} />
                    <Title target={"_blank"} title={"پلتفرم جان "} to={'https://jansnak.com/portal'} />
                    <Title title={" دانلود اپلیکیشن "} to={'download'} />
                    <Link to="/" onClick={() => window.location.href = "/home"} >
                        <img src="/images/logo.png" alt="جان اسنک" width={phone ? "33px" : "50px"} style={{ padding: '5px' }} />
                    </Link>

                    <Title target={"_blank"} title={"تور مجازی "} to={'https://tour.jansnak.com'} />
                    <Title title={" شکایات/پیگیری"} to={'complaint'} />
                    <Title title={" تماس با ما"} to={`contact/${0}`} />

                    <Button target="_blank" onClick={() => window.location.href = "https://superapp.jansnak.com/nearBranch"} variant='contained' sx={{ bgcolor: "#dc7200", color: "#000", fontWeight: 900, borderRadius: '15px' }}>  شعبه یاب جان </Button>

                </Box>
            }
        </AppBar>
    )
}

export default Navbar